let storeInstance = null
export const setStore = store => {
  storeInstance = store
}

export default function usePermission() {
  const getUserPermission = value => {
    if (!storeInstance) {
      console.warn('Store is not initialized in usePermission')
      return false
    }

    if (Array.isArray(value)) {
      const isPermissionExist = value.some(item => storeInstance.state.auth.userData.permissions.includes(item))
      return isPermissionExist
    }

    return storeInstance.state.auth.userData.permissions.includes(value)
  }

  return {
    getUserPermission,
  }
}
